/* =============================================================
 * import
 * ========================================================== */
import {eventObserver} from "./eventObserver";
import {gsap} from "gsap/gsap-core";
import {CustomEase} from "gsap/CustomEase";
import {smoother} from "../modules/parallax";

gsap.registerPlugin(CustomEase);
CustomEase.create("slide", ".32, .95, .6, 1");
CustomEase.create("curtain", ".25, .46, .45, .94");


/* =============================================================
 * globalNavi
 * グローバルナビに関する実行関数
 * ========================================================== */

export function globalNavi() {
  const listElements = document.querySelectorAll('.header_nav_list_item_link');
  const listElementsBottom = document.querySelectorAll('.header_nav_bottom_list_item_link');
  const hum = document.querySelector('.hum');
  // const hum = document.querySelector('.positive_header .hum');
  // const humNega = document.querySelector('.negative_header .hum');
  const logo = document.querySelector('.header_logo_link');
  // const logo = document.querySelector('.positive_header .header_logo_link');
  // const logoNega = document.querySelector('.negative_header .header_logo_link');
  const logoNav = document.querySelector('.header_nav_logo_link');
  const listeners = [];

  if (hum) {
    hum.addEventListener('click', humberger);
    logo.addEventListener('click', humberger);
    logoNav.addEventListener('click', humberger);
    // humNega.addEventListener('click', humberger);
    // logoNega.addEventListener('click', humberger);
    listeners.push([hum, 'click', humberger]);
    listeners.push([logo, 'click', humberger]);
    listeners.push([logoNav, 'click', humberger]);
    // listeners.push([humNega, 'click', humberger]);
    // listeners.push([logoNega, 'click', humberger]);

    listElements.forEach((elem) => {
      if (elem.parentNode.classList.contains('gnav_list_parent') === false) {
        elem.addEventListener('click', humberger, false);
        listeners.push([elem, 'click', humberger]);
      }
    });
    listElementsBottom.forEach((elem) => {
      elem.addEventListener('click', humberger, false);
      listeners.push([elem, 'click', humberger]);
    });
  }

  eventObserver.observeEvents(listeners);
}


/* =============================================================
 * humberger
 * ハンバーガーメニューの制御
 * ========================================================== */

export function humberger() {

  const html = document.documentElement;
  const humBg = document.getElementById('hum');
  const hum = document.querySelector('.hum');
  // const hum = document.querySelector('.positive_header .hum');
  // const humNega = document.querySelector('.negative_header .hum');
  const header = document.getElementById('header');
  const filter = document.getElementById('filter');

  if (humBg) {

    if (humBg.classList.contains('ing')) {
      return;
    }

    if (humBg.classList.contains('close')) {

      // 閉じている時
      if (!this.classList.contains('header_logo_link')) {

        humBg.classList.remove('close');
        hum.classList.remove('close');
        // humNega.classList.remove('close');
        header.classList.remove('close');
        filter.classList.remove('close');

        humBg.classList.toggle('open');
        hum.classList.toggle('open');
        // humNega.classList.toggle('open');
        header.classList.toggle('open');
        filter.classList.toggle('open');
        html.classList.toggle('is-fixed');

        humBg.classList.add('ing');
        humbergerAnim('open');
      }

    } else if (humBg.classList.contains('open')) {

      // 開いている時
      humBg.classList.add('close');
      hum.classList.add('close');
      // humNega.classList.add('close');
      header.classList.add('close');
      filter.classList.add('close');

      humBg.classList.toggle('open');
      hum.classList.toggle('open');
      // humNega.classList.toggle('open');
      header.classList.toggle('open');
      filter.classList.toggle('open');
      html.classList.toggle('is-fixed');

      humBg.classList.add('ing');
      humbergerAnim('close');

    } else {

      // 初動
      if (!this.classList.contains('header_logo_link')) {
        humBg.classList.toggle('open');
        hum.classList.toggle('open');
        // humNega.classList.toggle('open');
        header.classList.toggle('open');
        filter.classList.toggle('open');
        html.classList.toggle('is-fixed');

        humBg.classList.add('ing');
        humbergerAnim('open');
      }
    }

  }

}


function humbergerAnim(which) {

  const tl = gsap.timeline({
    repeat: 0,
    ease: "curtain",
    // onComplete: kvSlider,
  });

  const hum = document.getElementById('hum');
  const humBtn = document.querySelector('.hum');
  // const humBtn = document.querySelector('.positive_header .hum');
  // const humBtnNega = document.querySelector('.negative_header .hum');
  const nav = document.querySelector('#header_nav');
  const bg = document.querySelector('#hum .hum_bg');
  const logo = document.querySelector('#header_nav_logo');
  const lang = document.querySelector('.header_nav_bottom .lang_list');
  const reserve = document.querySelector('.header_nav_bottom .header_reserve');
  const sns = document.querySelectorAll('.header_nav_bottom .sns_list_item_link');
  const list = document.querySelectorAll('.header_nav_list_item_link');
  const listBottom = document.querySelectorAll('.header_nav_bottom_list_item_link');

  if (which === 'open') {

    if (smoother !== null) {
      smoother.paused(true); // スクロール停止
    }

    // open animation
    gsap.set(bg, {
      autoAlpha: 1,
    });
    gsap.set(nav, {
      autoAlpha: 1,
    });

    tl
      .fromTo(humBtn, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
      }, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
        duration: .6,
      }, "<")
/*
      .fromTo(humBtnNega, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
      }, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
        duration: .6,
      }, "<")
*/

      .fromTo(bg, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
      }, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 1,
      }, "<")

      .call(toggleClass, [hum, 'ing'], ">")

      .fromTo(logo, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
      }, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 2.4,
      }, "-=.8")

      .fromTo(list, {
        y: '100%',
      }, {
        y: '0%',
        ease: "slide",
        duration: .6,
        stagger: {
          each: .05,
        },
      }, "-=1.8")

      .fromTo(listBottom, {
        y: '100%',
      }, {
        y: '0%',
        ease: "slide",
        duration: .6,
        stagger: {
          each: .05,
        },
      }, "-=1.2")

      .fromTo(lang, {
        y: '100%',
      }, {
        y: '0%',
        ease: "slide",
        duration: .6,
      }, "-=0.8")

      .fromTo(reserve, {
        y: '100%',
      }, {
        y: '0%',
        ease: "slide",
        duration: .6,
      }, "-=0.8")

      .fromTo(sns, {
        y: '100%',
      }, {
        y: '0%',
        ease: "slide",
        duration: .6,
        stagger: {
          each: .05,
        },
      }, "-=0.8")


      .fromTo(humBtn, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
      }, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .8,
      }, "<")
      /*
      .fromTo(humBtnNega, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
      }, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .8,
      }, "<")
      */
    ;

  } else {

    // close animation

    if (smoother !== null) {
      smoother.paused(false); // スクロール開始
    }

    tl
      .fromTo(humBtn, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
      }, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
        duration: .8,
      }, "<")
      /*
      .fromTo(humBtnNega, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
      }, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
        duration: .8,
      }, "<")
      */

      .fromTo(logo, {
        webkitClipPath: 'polygon(0% 0%, 0% 100%, 50% 100%, 50% 0%, 50% 0%, 50% 100%, 100% 100%, 100% 0%)',
        clipPath: 'polygon(0% 0%, 0% 100%, 50% 100%, 50% 0%, 50% 0%, 50% 100%, 100% 100%, 100% 0%)',
      }, {
        webkitClipPath: 'polygon(0% 0%, 0% 100%, 0% 100%, 0% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 0%)',
        clipPath: 'polygon(0% 0%, 0% 100%, 0% 100%, 0% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 0%)',
        duration: 2.4,
      })

      .fromTo(list, {
        y: '0%',
      }, {
        y: '100%',
        ease: "slide",
        duration: .6,
      }, "-=2.2")

      .fromTo(listBottom, {
        y: '0%',
      }, {
        y: '100%',
        ease: "slide",
        duration: .6,
      }, "<")

      .fromTo(lang, {
        y: '0%',
      }, {
        y: '100%',
        ease: "slide",
        duration: .6,
      }, "<")

      .fromTo(reserve, {
        y: '0%',
      }, {
        y: '100%',
        ease: "slide",
        duration: .6,
      }, "<")

      .fromTo(sns, {
        y: '0%',
      }, {
        y: '100%',
        ease: "slide",
        duration: .6,
      }, "<")

      .fromTo(bg, {
        webkitClipPath: 'polygon(0% 0%, 0% 100%, 50% 100%, 50% 0%, 50% 0%, 50% 100%, 100% 100%, 100% 0%)',
        clipPath: 'polygon(0% 0%, 0% 100%, 50% 100%, 50% 0%, 50% 0%, 50% 100%, 100% 100%, 100% 0%)',
      }, {
        webkitClipPath: 'polygon(0% 0%, 0% 100%, 0% 100%, 0% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 0%)',
        clipPath: 'polygon(0% 0%, 0% 100%, 0% 100%, 0% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 0%)',
        duration: 1,
      }, "-=1.8")

      .fromTo(humBtn, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
      }, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .6,
      }, ">")
      /*
      .fromTo(humBtnNega, {
        webkitClipPath: 'inset(0% 50% 0% 50%)',
        clipPath: 'inset(0% 50% 0% 50%)',
      }, {
        webkitClipPath: 'inset(0% 0% 0% 0%)',
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .6,
      }, ">")
      */

      .set(nav, {
        autoAlpha: 0,
        zIndex: 0,
      }, ">")

      .set(bg, {
        autoAlpha: 0,
      }, ">")

      .call(toggleClass, [hum, 'ing'], ">")
    ;

  }
}

/* =============================================================
 * checkParentDirectory
 * 現在のディレクトリ名からサブページの有無を判定
 * ========================================================== */
export function checkParentDirectory(path) {
  let reg;
  let result;
  let hasChildDir = false;

  // 表示中のページ判定
  const childPathArray = ['/service/', '/works/', '/company/', '/about/', '/media/', '/contact/'];
  childPathArray.forEach(dir => {
    reg = new RegExp(dir);
    result = path.match(reg);
    if (result != null) {
      hasChildDir = true;
      return;
    }
  });
  return hasChildDir;
}


function toggleClass(e, n) {
  e.classList.toggle(n);
}
